import { render } from "./site-header-group.vue?vue&type=template&id=2744733c"
import script from "./site-header-group.vue?vue&type=script&lang=js"
export * from "./site-header-group.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__